export const templateName = 'templateName';
export const shortcut = 'shortcut';
export const isPrivate = 'isPrivate';
export const status = 'status';
export const body = 'body';
export const description = 'description';
